// Constantes
window.TITLE_ERROR = 'Ups...'

window.TITLE_SUCCESS = 'ITFA'

window.positions = [
  { value: 'GK', text: 'GK - PO' },
  { value: 'CB', text: 'CB - DFC' },
  { value: 'LB', text: 'LB - LTI' },
  { value: 'RB', text: 'RB - LTD' },
  { value: 'CDM', text: 'CDM - MCD' },
  { value: 'LM', text: 'LM - MI' },
  { value: 'RM', text: 'RM - MD' },
  { value: 'CAM', text: 'CAM - MCO' },
  { value: 'ST', text: 'ST - DC' }
]

window.consoles = [
  'PSN', 'XBOX', 'PC'
]

window.chemStyles = [
  { value: 1, text: 'BASIC' },
  { value: 2, text: 'WALL' },
  { value: 3, text: 'BACKBONE' },
  { value: 4, text: 'MAESTRO' },
  { value: 5, text: 'FINISHER' },
  { value: 6, text: 'HUNTER' }
]

window.langs = [
  { value: 'es', text: 'Español' },
  { value: 'en', text: 'English' },
  { value: 'pt', text: 'Português' },
  { value: 'it', text: 'Italiano' },
  { value: 'de', text: 'Deutsch' },
  { value: 'fr', text: 'Le français' }
]

window.coins = [
  { price: 2.5, quantity: 1500 },
  { price: 5.5, quantity: 3500 },
  { price: 10.5, quantity: 6500 },
  { price: 15.5, quantity: 10500 }
]

window.premiums = [
  { month: 1, price: 4 },
  { month: 3, price: 10 },
  { month: 6, price: 20 },
  { month: 12, price: 40 }
]
